import { render, staticRenderFns } from "./FundTransferExternalCard.vue?vue&type=template&id=2b87a72a&scoped=true&"
import script from "./FundTransferExternalCard.vue?vue&type=script&lang=js&"
export * from "./FundTransferExternalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b87a72a",
  null
  
)

export default component.exports